import React, { useState } from 'react';
import { Typography, Chip } from '@mui/material';
import { Game } from '../../../../interfaces/Games.interface';
import SharedModal from './BCCoveredGamesModal';
import { Streamingpackage } from '../../../../interfaces/StreamingProvider.interface';
import { StyledContainer, StyledItem } from './BCCoveredGames.styled';
import { LiveOrHighlightOrBoth } from '../providerXcompetitonsXgames/types/HighlightOrLiveOrBoth.types';

type BCCoveredGamesProps = {
  totalCoveredGames: Game[];
  gamesFromSelectedTeams: Game[];
  mode: LiveOrHighlightOrBoth;
  uncoveredGames: Game[];
  providerPackageCoverage: { [key: string]: Set<number> };
  allProviders: Streamingpackage[];
  bestProvider: Streamingpackage[];
  caption1: string;
  caption2: string;
};

const BCCoveredGames: React.FC<BCCoveredGamesProps> = ({
  totalCoveredGames,
  gamesFromSelectedTeams,
  mode,
  uncoveredGames,
  providerPackageCoverage,
  allProviders,
  bestProvider,
  caption1,
  caption2,
}) => {
  const [openCoveredModal, setOpenCoveredModal] = useState(false);
  const [openUnCoveredModal, setOpenUnCoveredModal] = useState(false);

  const handleOpenCoveredModal = () => setOpenCoveredModal(true);
  const handleCloseModal = () => setOpenCoveredModal(false);
  const handleOpenUnCoveredModal = () => setOpenUnCoveredModal(true);
  const handleCloseUnCoveredModal = () => setOpenUnCoveredModal(false);
  const coverageInPercent = (
    (totalCoveredGames.length / gamesFromSelectedTeams.length) *
    100
  ).toFixed(2);
  const uncoverageInPercent = (
    (uncoveredGames.length / gamesFromSelectedTeams.length) *
    100
  ).toFixed(2);
  return (
    <>
      <StyledContainer>
        <StyledItem elevation={3}>
          <Typography variant="h5" gutterBottom fontStyle="bold">
            {caption1}
          </Typography>
          <Typography variant="subtitle2" color="textDisabled">
            {mode === 'Live'
              ? 'Number of games that are live-streamed'
              : mode === 'Highlight'
                ? 'Number of games with available highlights'
                : 'Number of games with live streams and subsequent highlights'}
          </Typography>
          <Typography variant="subtitle1">
            {totalCoveredGames.length} of {gamesFromSelectedTeams.length}{' '}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {coverageInPercent} %
          </Typography>

          <Chip
            label="Show details"
            onClick={handleOpenCoveredModal}
            clickable
            color="primary"
            sx={{
              marginTop: 2,
              maxWidth: '100px',
              justifyContent: 'center',
              display: 'flex',
            }}
          />
        </StyledItem>

        <StyledItem elevation={3}>
          <Typography variant="h5" gutterBottom fontStyle="bold">
            {caption2}
          </Typography>
          <Typography variant="subtitle2" color="textDisabled">
            {mode === 'Live'
              ? 'Number of games that are not live-streamed'
              : mode === 'Highlight'
                ? 'Number of games with no highlights'
                : 'Number of games with live streams and subsequent highlights'}
          </Typography>
          <Typography variant="subtitle1">
            {uncoveredGames.length} of {gamesFromSelectedTeams.length}{' '}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {uncoverageInPercent} %
          </Typography>

          <Chip
            label="Show details"
            onClick={handleOpenUnCoveredModal}
            clickable
            color="primary"
            sx={{
              marginTop: 2,
              maxWidth: '100px',
              justifyContent: 'center',
              display: 'flex',
            }}
          />
        </StyledItem>
      </StyledContainer>

      <SharedModal
        bestProvider={bestProvider}
        providers={allProviders}
        providerPackageCoverage={providerPackageCoverage}
        games={totalCoveredGames}
        handleCloseModal={handleCloseModal}
        openModal={openCoveredModal}
        heading={'Covered Games'}
        type="COVERED"
      />
      <SharedModal
        bestProvider={bestProvider}
        providers={allProviders}
        providerPackageCoverage={providerPackageCoverage}
        games={uncoveredGames}
        handleCloseModal={handleCloseUnCoveredModal}
        openModal={openUnCoveredModal}
        heading={'Uncovered Games'}
        type="UNCOVERED"
      />
    </>
  );
};

export default BCCoveredGames;
